import React from "react"
import { useSearchParams } from "react-router-dom"

import { ThemeLayoutEnum } from "@/models/ITrackingPageOptions"
import {
  THEME_LAYOUT_APP_WINDOW_CONTENT_PARAM,
  USE_THEME_LAYOUT_MODAL_HOST,
} from "@/pages/TrackingPage/DisplayOptions/components/themeLayoutAppWindow"
import ThemeLayoutAppWindowHost from "@/pages/TrackingPage/ThemeLayoutCustomize/ThemeLayoutAppWindowHost"
import ThemeLayoutCustomizePageContent from "@/pages/TrackingPage/ThemeLayoutCustomize/ThemeLayoutCustomizePageContent"
import ThemeLayoutModalHost from "@/pages/TrackingPage/ThemeLayoutCustomize/ThemeLayoutModalHost"
import { isShopifyEmbedded } from "@/utils/appBridge"

/**
 * /tracking-page/customizeShowcase（逻辑同 CustomizeBackdropPage）
 */
const CustomizeShowcasePage = () => {
  const [searchParams] = useSearchParams()
  const isAppWindowContentFrame = searchParams.get(THEME_LAYOUT_APP_WINDOW_CONTENT_PARAM) === "1"
  const isShopifyMerchantEmbedded = isShopifyEmbedded() && !window.isFromAdmin

  if (!isShopifyMerchantEmbedded || isAppWindowContentFrame) {
    return <ThemeLayoutCustomizePageContent variant={ThemeLayoutEnum.SHOWCASE} />
  }

  return USE_THEME_LAYOUT_MODAL_HOST
    ? <ThemeLayoutModalHost subPath="customizeShowcase" />
    : <ThemeLayoutAppWindowHost subPath="customizeShowcase" />
}

export default CustomizeShowcasePage
